import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {withTranslation, WithTranslation} from "react-i18next";
import {User, UserState} from "../../store/user/types";
import {EutrState, EutrElement, EutrDocument, EutrPreSupplier} from "../../store/eutr/types";
import {compose} from "redux";
import {connect} from "react-redux";
import {AppState} from "../../store";
import Paper from '@material-ui/core/Paper';
import {setEditingEutrElements, setEditingEutrElement, setEditingEutrPreSupplier} from "../../store/eutr/actions";
import {Button, createStyles, Theme, Toolbar, withStyles, WithStyles, TextField} from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Divider from '@material-ui/core/Divider';
import countries from '../../common/utils/countries.json';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import Alert from "../../common/component/Alert";

type ElementEditProps = RouteComponentProps & WithTranslation & WithStyles & {
    userState: UserState;
    eutrState: EutrState;
    setEditingEutrElements: typeof setEditingEutrElements;
    setEditingEutrElement: typeof setEditingEutrElement;
    setEditingEutrPreSupplier: typeof setEditingEutrPreSupplier;
}

interface IElementEditState {
    showError: boolean;
    errorMessage: string;
}

class EutrElementEdit extends React.Component<ElementEditProps, IElementEditState> {

    state = {
        showError: false,
        errorMessage: ''
    }

    render() {
        const t = this.props.t;
        const element = this.props.eutrState.editingEutrElement!;
        if (!element) {
            return null;
        }
        return (
            <Paper style={{padding: "10px", margin: "25px"}}>
                <Toolbar>
                    <Typography color="inherit" variant="h6">{t('EutrElementEdit.title')}</Typography>
                </Toolbar>
                <form className={this.props.classes.editForm} noValidate autoComplete="off">
                    <FormControl margin="normal" className={this.props.classes.control} fullWidth required>
                        <InputLabel htmlFor="description">{t('EutrElementEdit.description')}</InputLabel>
                        <Input name="description" value={element.description || ''}
                               onChange={this.handleChange('description')}/>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.smallControl} required>
                        <InputLabel htmlFor="volume">{t('EutrElementEdit.volume')}</InputLabel>
                        <Input name="volume" value={element.volume || ''}
                               onChange={this.handleChange('volume')}/>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.smallControl} required>
                        <InputLabel htmlFor="weight">{t('EutrElementEdit.weight')}</InputLabel>
                        <Input name="weight" value={element.weight || ''}
                               onChange={this.handleChange('weight')}/>
                    </FormControl>
                    <br/>
                    <FormControl margin="normal" className={this.props.classes.mediumControl} required>
                        <InputLabel
                            htmlFor="kindOfWoodScientific">{t('EutrElementEdit.woodTypeScientific')}</InputLabel>
                        <Input name="kindOfWoodScientific" value={element.kindOfWoodScientific || ''}
                               onChange={this.handleChange('kindOfWoodScientific')}/>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.mediumControl}>
                        <InputLabel htmlFor="kindOfWoodTrade">{t('EutrElementEdit.woodType')}</InputLabel>
                        <Input name="kindOfWoodTrade" value={element.kindOfWoodTrade || ''}
                               onChange={this.handleChange('kindOfWoodTrade')}/>
                    </FormControl>
                    <br/>
                    <FormControl margin="normal" className={this.props.classes.smallControl} required>
                        <InputLabel htmlFor="countryOfOrigin">{t('EutrElementEdit.countryOfOrigin')}</InputLabel>
                        <Select
                            value={element.countryOfOrigin || ''}
                            onChange={this.handleChange('countryOfOrigin')}
                            inputProps={{name: 'countryOfOrigin', id: 'countryOfOrigin'}}>
                            {countries.map(c => <MenuItem key={c.Code} value={c.Code}>{c.Name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.smallControl} required>
                        <InputLabel htmlFor="region">{t('EutrElementEdit.region')}</InputLabel>
                        <Input name="region" value={element.region || ''}
                               onChange={this.handleChange('region')}/>
                    </FormControl>
                    <br/>
                    <FormControl margin="normal" className={this.props.classes.control}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={element.flegt || false} value="flegt"
                                                onChange={this.handleChange('flegt')} color="primary"/>
                                }
                                label={t('EutrElementEdit.flegt')}
                            />
                        </FormGroup>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.control}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={element.cites || false} value="cites"
                                              onChange={this.handleChange('cites')} color="primary"/>
                                }
                                label={t('EutrElementEdit.cites')}
                            />
                        </FormGroup>
                    </FormControl>
                    <br/>
                    <FormControl margin="normal" className={this.props.classes.mediumControl}>
                        <InputLabel htmlFor="certification">{t('EutrElementEdit.certification')}</InputLabel>
                        <Input name="certification" value={element.certification || ''}
                               onChange={this.handleChange('certification')}/>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.mediumControl}>
                        <InputLabel htmlFor="certificateNumber">{t('EutrElementEdit.certificateNumber')}</InputLabel>
                        <Input name="certificateNumber" value={element.certificateNumber || ''}
                               onChange={this.handleChange('certificateNumber')}/>
                    </FormControl>
                    <br/>
                    <FormControl margin="normal" className={this.props.classes.mediumControl}>
                        <FormLabel>{t('EutrElementEdit.documents')}</FormLabel>
                        <List component="nav">
                            {element.documents && element.documents.map((d: EutrDocument, i: number) => ([
                                <ListItem button component="a" href={d.href} key={i}>
                                    <ListItemText primary={d.name}/>
                                    <ListItemSecondaryAction>
                                        <IconButton aria-label={t('common.delete')}
                                                    onClick={() => this.removeDocument(i)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>,
                                <Divider/>
                            ]))}
                        </List>
                        <input id="document-upload-input" style={{display: 'none'}} type="file"
                               onChange={(e) => this.uploadDocument(e.target.files!)}/>
                        <label htmlFor="document-upload-input" className={this.props.classes.listButton}>
                            <Button variant="contained" color="primary" component="span">{t('common.upload')}</Button>
                        </label>
                    </FormControl>
                    <FormControl margin="normal" className={this.props.classes.mediumControl}>
                        <FormLabel>{t('EutrElementEdit.supplyChain')}</FormLabel>
                        <List component="nav">
                            {element.preSuppliers && element.preSuppliers.map((s: EutrPreSupplier, i: number) => ([
                                <ListItem key={i}>
                                    <ListItemText primary={s.name}
                                                  className={this.props.classes.twoActionsListItem}/>
                                    <ListItemSecondaryAction>
                                        <IconButton aria-label={t('common.edit')}
                                                    onClick={() => this.editSupplier(s, i)}>
                                            <EditIcon/>
                                        </IconButton>
                                        <IconButton aria-label={t('common.delete')}
                                                    onClick={() => this.removeSupplier(i)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>,
                                <Divider/>
                            ]))}
                        </List>
                        <Button variant="contained" color="primary" onClick={() => this.addSupplier()}
                                className={this.props.classes.listButton}>{t('common.add')}</Button>
                    </FormControl>
                </form>
                <Divider/>
                <Toolbar>
                    <div className={this.props.classes.toolbarButtonContainer}>
                        <Button variant="contained" color="primary" onClick={() => this.save()}
                                className={this.props.classes.button}
                                disabled={!this.canSave()}>{t('common.save')}</Button>
                        <Button variant="contained" onClick={() => this.cancel()}
                                className={this.props.classes.button}>{t('common.cancel')}</Button>
                    </div>
                </Toolbar>
                <Alert open={this.state.showError} message={this.state.errorMessage}
                       onClose={() => this.setState({showError: false})} type='error'/>
            </Paper>
        );
    }

    handleChange = (name: string) => (event: React.ChangeEvent) => {
        let value;
        if ((event.target as HTMLInputElement).type === 'checkbox') {
            value = (event.target as HTMLInputElement).checked;
        } else {
            value = (event.target as HTMLInputElement).value;
        }
        let element = this.props.eutrState.editingEutrElement!;
        element[name] = value;
        this.props.setEditingEutrElement(element);
    };

    uploadDocument = (files: FileList) => {
        let file = files[0];
        let formData = new FormData();
        formData.append('file', file);
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/documents';
        axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(res => {
                if (res.status == 201) {
                    let location = res.headers.location;
                    let id = location.substring(location.lastIndexOf('/') + 1);
                    console.log('Uploaded document ' + file.name + ' with id ' + id);
                    let element = this.props.eutrState.editingEutrElement!;
                    let documents = element.documents ? element.documents : [];
                    documents.push({id: id, name: file.name, href: location});
                    element.documents = documents;
                    this.props.setEditingEutrElement(element);
                } else {
                    console.log('Failed to upload document: ' + file.name + '!');
                    this.setState({
                        showError: true,
                        errorMessage: this.props.t('EutrElementEdit.uploadDocumentFailed')
                    });
                }
            })
            .catch(err => {
                console.log('Failed to upload document: ' + file.name + '!');
                console.log(err);
                this.setState({showError: true, errorMessage: this.props.t('EutrElementEdit.uploadDocumentFailed')});
            })
    }

    removeDocument(index: number) {
        console.log('Removing the document with index. ' + index);
        let element = this.props.eutrState.editingEutrElement!;
        element.documents!.splice(index, 1);
        this.props.setEditingEutrElement(element);
    }

    addSupplier() {
        let supplier = {name: ''};
        this.editSupplier(supplier, -1);
    }

    editSupplier(supplier: EutrPreSupplier, index: number) {
        console.log('Editing the eutr supplier with index ' + index);
        this.props.setEditingEutrPreSupplier(JSON.parse(JSON.stringify(supplier))); // clone before edit
        this.props.history.push({
            pathname: `${this.props.match.url}/suppliers/edit`,
            state: {editingPreSupplierIndex: index}
        });
    }

    removeSupplier(index: number) {
        console.log('Removing the eutr supplier with index. ' + index);
        let element = this.props.eutrState.editingEutrElement!;
        element.preSuppliers!.splice(index, 1);
        this.props.setEditingEutrElement(element);
    }

    canSave() {
        const element = this.props.eutrState.editingEutrElement!;
        return element
            && element.description
            && (element.volume || element.weight)
            && element.kindOfWoodScientific
            && element.countryOfOrigin
            && element.region;
    }

    save() {
        let elements = [...this.props.eutrState.editingEutrElements];
        let element = this.props.eutrState.editingEutrElement!;
        let index = elements.findIndex(e => e.sequentialNumber == element.sequentialNumber);
        if (index > -1) {
            elements[index] = element;
        } else {
            elements.push(element);
        }
        this.props.setEditingEutrElements(elements);
        this.props.history.goBack();
    }

    cancel() {
        this.props.history.goBack();
    }
}

const styles = ({palette, spacing}: Theme) => createStyles({
    toolbarButtonContainer: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-end'
    },
    button: {
        marginLeft: spacing.unit
    },
    listButton: {
        width: 'fit-content',
        alignSelf: 'flex-end'
    },
    control: {
        marginLeft: spacing.unit,
        marginRight: spacing.unit
    },
    smallControl: {
        marginLeft: spacing.unit,
        marginRight: spacing.unit,
        width: 200
    },
    mediumControl: {
        marginLeft: spacing.unit,
        marginRight: spacing.unit,
        width: 400
    },
    largeControl: {
        marginLeft: spacing.unit,
        marginRight: spacing.unit,
        width: 800
    },
    twoActionsListItem: {
        marginRight: 54,
    },
    editForm: {}
});

const mapStateToProps = (state: AppState) => ({
    userState: state.user,
    eutrState: state.eutr
});

export default compose(
    withRouter,
    withStyles(styles),
    withTranslation('common'),
    connect(mapStateToProps, {setEditingEutrElements, setEditingEutrElement, setEditingEutrPreSupplier})
)(EutrElementEdit) as any;